import * as React from 'react'

export default (props) =>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
        <path d="M14.3 9.5L8.1 6.1c-.3-.2-.7-.1-.9.2 0 .1-.1.2-.1.3v6.7c0 .2.1.4.3.6.1 0 .3.1.4.1.1 0 .2 0 .3-.1l6.2-3.3c.3-.2.4-.6.3-.9-.1-.1-.2-.2-.3-.2zm-5.9 2.8V7.7l4.2 2.3-4.2 2.3z" />
        <path d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm0 18.8c-4.9 0-8.8-3.9-8.8-8.8S5.1 1.2 10 1.2s8.8 3.9 8.8 8.8c0 4.8-4 8.8-8.8 8.8z" />
    </svg>
